module.exports = __webpack_public_path__ + "static/media/deltaTChart.e6820bc9.png";